import React, { Children, useEffect, useState } from 'react'
import classes from '../styles/Modal.module.scss'
import { useDispatch,useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import {closeModal,selectModalRedirect,selectModalTitle,selectModalBody,setModalBody,selectActionPayload,selectActionType} from '../redux/features/modalSlice'

import { selectNbrItems,clear,clearCouponCode, clearDiscountedPrice } from '../redux/features/cartSlice'
import { selectUser,logout } from '../redux/features/authSlice'
import { Link,useLocation,useNavigate } from 'react-router-dom'
import { clearShipping } from '../redux/features/checkoutSlice'

const Modal = () => {

    const [status, setStatus] = useState("")
    const [confirmed, setConfirmed] = useState(false)
    const [confirmBtn, setConfirmBtn] = useState("OK")
    const dispatch= useDispatch()
    const navigate=useNavigate()
    const modalTitle =useSelector(selectModalTitle)
    const modalbody=useSelector(selectModalBody)
    const actionPayload=useSelector(selectActionPayload)
    const actionType=useSelector(selectActionType)
    const location = useLocation()

    const [orderResponse,setOrderResponse] = useState("")

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // const navigateOnRedirectTrue= ()=>{
    //     if (redirectOnModalOK){
    //         console.log("call in redirect")
    //         Navigate({ to: '/' })

    //     }     
    // }

    useEffect(() => {
        //console.log("called before redirect")
        
        try {

            switch (actionType) {

                case "CREATE_ORDER":
                    setConfirmBtn("Confirm")
                    break;

                case "DELETE_PRODUCT":
                    setConfirmBtn("Confirm")
                    break;

                case "EMAIL_SUBSCRIPTION":
                    setConfirmBtn("OK")
                    break;

                case "ADD_TO_CART":
                    setConfirmBtn("OK")
                    break;

                case "CREATE_PRODUCT":
                    setConfirmBtn("OK")
                    break;

                default:
                break;
        }

        } catch (err) {
            //console.log(err);
        }
        
    }, [])

    const closeit= ()=>{
        dispatch(closeModal())
        //console.log("clicked on close")
        // dispatch(logout())
        // dispatch(clear())
        // dispatch(clearShipping())
        // navigate('/')
    }

    const nothing=()=>{
        return null
    }

    const confirm= async ()=>{

        try {

            switch (actionType) {

                case "CREATE_ORDER":
                    
                    const { data } = await axios.post(process.env.REACT_APP_BACKEND_URL+'order/create', actionPayload);
                    
                    //if the order was successfully saved then take the user to order page so he can pay the order
                    //console.log("saved the order")

                    //console.log('Ordered with success!')
                    
                    //setOrderResponse("Ordered with success!")
                    dispatch(setModalBody("Ordered with success!"))
                    setConfirmed(true)
                    await sleep(2000);

                    dispatch(logout())
                    dispatch(clear())
                    dispatch(clearShipping())
                    dispatch(clearDiscountedPrice())
                    dispatch(clearCouponCode())
                    dispatch(closeModal())
                    navigate('/')

                    break;

                case "DELETE_PRODUCT":
                    // Send delete request to the backend with the id of the product to delete
                    const { res } = await axios.delete(process.env.REACT_APP_BACKEND_URL+'product/delete/'+actionPayload.id,
                    {
                        headers: {
                            authorization: `Bearer ${actionPayload.token}`,
                        },
                    }
                    )
                    //console.log(res)
                    dispatch(closeModal())
                    break;
                
                case "EMAIL_SUBSCRIPTION":
                    dispatch(closeModal())
                    navigate('/men');
                    break;
                
                case "ADD_TO_CART":
                    dispatch(closeModal())
                    break;
                
                case "CREATE_PRODUCT":
                    dispatch(closeModal())
                    break;
                    
                default:
                    break;
            }

        } catch (err) {
            //console.log(err);
        }

        
        //console.log("clicked on confirm")
        
    }

    return (
        <div className={classes.container}>
            <div className={classes.wrapper}>
                <div className={classes.header}>{modalTitle}<div onClick={()=> dispatch(closeModal())}>X</div></div>
                <div className={classes.body+" "+classes.message} data-test="modal-message" style={{ whiteSpace: "pre-line" }}>{modalbody}</div> 
                <div className={classes.footer}>
                    {confirmBtn == "Confirm" && <button className={classes.btn} id="exit" onClick={()=> closeit() }>Cancel</button>}
                    <button className={classes.btn} id="exit" onClick={!confirmed ? ()=> confirm():()=> nothing()}>{confirmBtn}</button>
                </div>
            </div>
        </div>
    )

}

export default Modal